module.exports = __webpack_public_path__ + "img/after-4.89a70377.png";